export { default as ThreeDStockContentImageLensSelectionOverlay } from './ThreeDStockContentImageLensSelectionOverlay';
